<template>
  <el-scrollbar>
    <label style="margin-left: 5px;font-weight: bold">员工信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="employeeData" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="工号：" required>
              <el-input v-model="employeeData.employee_no" placeholder="工号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名：" required>
              <el-input v-model="employeeData.employee_name" placeholder="姓名" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="部门：" required>
              <el-cascader v-model="employeeData.department_ids" :options="departmentList"
                           :props="optionProps"  style="width: 100%"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div style="display: flex;justify-content: space-between">
      <label style="margin-left: 5px;font-weight: bold">身份信息:</label>
      <div>
        <el-button type="primary" plain size="small" @click="getIdCardInfo">读取身份证信息</el-button>
        <label style="margin-left: 5px;font-size: small">请先将中国大陆身份证放置在高拍仪身份证识别区，再点击“读取身份证信息”按钮读取身份证信息</label>
      </div>
    </div>
    <el-card style="margin: 5px">
      <el-form :model="idCardInfo" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-row>
              <el-col :span="24">
                <el-form-item label="姓名：" >
                  <el-input v-model="idCardInfo.employee_name" placeholder="姓名" clearable />
                </el-form-item>
                <el-form-item label="性别：">
                  <el-select v-model="idCardInfo.gender" placeholder="性别" clearable>
                    <el-option v-for="item in sexOption" :key="item.id" :label="item.field_name" :value="item.field_name"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="民族：">
                  <el-select v-model="idCardInfo.ethnicity" placeholder="民族" clearable>
                    <el-option v-for="item in nationOption" :key="item.id" :label="item.field_name" :value="item.field_name"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="出生日期：" >
                  <el-date-picker v-model="idCardInfo.date_of_birth" type="date"
                                  value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%" @change="formattedMonth"/>
                </el-form-item>
                <el-form-item label="月份：">
                  <el-input v-model="idCardInfo.birth_month" placeholder="月份" clearable disabled/>
                </el-form-item>
                <el-form-item label="公民身份证号码：">
                  <el-input v-model="idCardInfo.id_card_no" placeholder="公民身份证号码" clearable />
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6" :offset="5">
            <div>
              <el-image :src="idCardInfo.avatar_show" style="width: 130px;height: 160px;margin-top: 60px">
                <template #error>
                  <div class="image-slot">
                    <el-icon><icon-picture /></el-icon>
                  </div>
                </template>
              </el-image>
            </div>
          </el-col>
        </el-row>
        <el-form-item label="住址：">
          <el-input v-model="idCardInfo.address" placeholder="住址" clearable />
        </el-form-item>
        <el-form-item label="签发机关：">
          <el-input v-model="idCardInfo.issue_authority" placeholder="签发机关" clearable />
        </el-form-item>
        <el-form-item label="有效期限：">
          <el-col :span="11">
            <el-date-picker v-model="idCardInfo.expire_date_start" type="date"
                            value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
          </el-col>
          <el-col :span="0.5" class="text-center">
            <span class="text-gray-500">-</span>
          </el-col>
          <el-col :span="12">
            <el-date-picker v-model="idCardInfo.expire_date_end" type="date"
                            value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
          </el-col>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="婚姻状况：">
              <el-select v-model="idCardInfo.marital_status" placeholder="婚姻状况" clearable>
                <el-option v-for="item in marriageList" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="籍贯：">
              <el-input v-model="idCardInfo.origin_domicile" placeholder="籍贯" clearable/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="政治面貌：">
              <el-select v-model="idCardInfo.political_affiliation" placeholder="政治面貌" clearable>
                <el-option v-for="item in politicaleOption" :key="item.id" :label="item.field_name" :value="item.field_name"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="照片：">
              <el-button type="primary" plain style="width: 100px" @click="openCameraMain('idCard1')">人像页拍照</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <el-button type="primary" plain style="width: 100px" @click="openCameraMain('idCard2')">国徽页拍照</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <FrameItem v-model="idCardInfo.man_photo_show" :file-list="employeeData.man_photo_show_obj" :item="uploadImgObj"></FrameItem>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <FrameItem v-model="idCardInfo.nation_photo_show" :file-list="employeeData.nation_photo_show_obj" :item="uploadImgObj"></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">非大陆身份信息:</label>
    <el-card style="margin: 5px">
      <el-form :model="idCardInfo" class="demo-form-inline" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件类型：">
              <el-select v-model="idCardInfo.card_type_othoer" placeholder="证件类型" clearable>
                <el-option v-for="item in cardTypeList" :key="item.id" :label="item.document_name" :value="item.id"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号码：">
              <el-input v-model="idCardInfo.id_card_no_other" placeholder="证件号码" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="照片：">
              <el-button type="primary" plain style="width: 100px" @click="openCameraMain('card1')">正面拍照</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="">
              <el-button type="primary" plain style="width: 100px" @click="openCameraMain('card2')">反面拍照</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item>
              <FrameItem v-model="idCardInfo.man_photo_show_other" :file-list="employeeData.man_photo_show_other_obj" :item="uploadImgObj"></FrameItem>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <FrameItem v-model="idCardInfo.nation_photo_show_other" :file-list="employeeData.nation_photo_show_other_obj" :item="uploadImgObj"></FrameItem>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-row>
      <el-col :span="24" style="text-align: center">
        <el-button type="primary" :loading="loading" @click="saveEmployeeInfo">保存</el-button>
      </el-col>
    </el-row>
  </el-scrollbar>
  <el-dialog v-model="dialogVisible" style="width: 800px;height: 550px;">
    <img id="view2" src="http://127.0.0.1:38088/video=stream&camidx=1" alt="副摄像头" style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCamera">取消</el-button>
        <el-button type="primary" @click="takePhoto">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
  <el-dialog v-model="dialogVisibleTwo" style="width: 800px;height: 550px;">
    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头" style="width: 770px;height:450px;">
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="closeCameraMain">取消</el-button>
        <el-button type="primary" @click="takePhotoTwo">
          拍照
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>

import {Upload} from "@element-plus/icons-vue";
import { Picture as IconPicture } from '@element-plus/icons-vue'
import { ref } from 'vue';
import axios from 'axios'

export default {
  name: "EmployeeIdCard",
  components: {Upload,IconPicture,ref},
  inject: ['$fn'],
  setup() {
    const cameraUrl = ref('http://127.0.0.1:38088/video=stream&camidx=1');

    return {
      cameraUrl,
    };
  },
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed: {
    boolList(){
      return this.$store.getters['core/getDictList']('bool');
    },
    marriageList(){
      return this.$store.getters['core/getDictList']('marriage_status');
    }
  },
  data() {
    return {
      optionProps: {
        value: 'id',
        label: 'name'
      },
      employeeData: {
        employee_no:'',
        employee_name:'',
        department_ids:[],
        idCardInfo:{},
      },
      dialogVisible:false,
      dialogVisibleTwo:false,
      photoType:'',
      is_custom:true,
      idCardInfo:{
      },
      departmentList: [],
      employeeTypeList: [],
      cardTypeList:[],
      loading: false,
      imageUrl: '',
      uploadObj: {
        component: 'file_upload',
        limit: 1,
      },
      uploadImgObj:{
        component: 'image_upload',
        limit: 1,
      },
      sexOption:[],
      nationOption:[],
      marriageOption:[],
      residenceOption:[],
      politicaleOption:[]
    }
  },
  methods: {
    async loadEmployeeInfo() {
      let params = {id: this.parentData.employee_id}
      let dbEmployee = await this.$http('employeeInfoService.getEmployeeIdCardInfo', params);
      if(dbEmployee){
        this.employeeData = dbEmployee;
        this.idCardInfo.employee_id = dbEmployee.id;
        if(dbEmployee.idCardInfo){
          this.idCardInfo = dbEmployee.idCardInfo;
        }
      }
    },
    //获取部门列表
    async getDepartmentList() {
      this.departmentList = await this.$http('sysUserDepartmentService.getDepartmentData');
    },
    //获取职位
    async getPosition() {
      let params = {modelId: "hr_position"}
      this.positionList = await this.$http('employeeHRService.getAll',params);
    },
    //获取职级
    async getJobLevel() {
      let params = {modelId: "hr_rank"}
      this.jobLevelList = await this.$http('employeeHRService.getAll',params);
    },
    //获取员工类型
    async getEmployeeType() {
      let params = {modelId: "hr_employee_type"}
      this.employeeTypeList = await this.$http('employeeHRService.getAll',params);
    },
    //获取证件类型
    async getCardType() {
      let params = {modelId: "hr_document"}
      this.cardTypeList = await this.$http('employeeHRService.getAll',params);
    },
    //获取性别
    async getSexOption() {
      let params = {group_id: "sys02-sexType"}
      this.sexOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取民族
    async getNationOption() {
      let params = {group_id: "sys02-nationType"}
      this.nationOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取婚姻
    async getMarriageOption() {
      let params = {group_id: "sys02-marriage"}
      this.marriageOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取户籍
    async getResidenceOption() {
      let params = {group_id: "sys02-residenceType"}
      this.residenceOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    //获取政治面貌
    async getPoliticalOption() {
      let params = {group_id: "sys02-politicalStatus"}
      this.politicaleOption = await this.$http('employeeInfoService.getRosterOptionList',params);
    },
    formattedMonth() {
      if(this.idCardInfo.date_of_birth){
        const date = new Date(this.idCardInfo.date_of_birth)
        this.idCardInfo.birth_month =  `${date.getMonth() + 1}月`
      }else {
        this.idCardInfo.birth_month = ''
      }
    },
    //获取二代身份证信息
    getIdCardInfo(){
      axios.get("http://127.0.0.1:38088/card=idcard").then(response=>{
        if(response){
          let data = {userInfo: response.data};
          this.$http('photoService.getIdCardInfo',data, false).then(data => {
            this.idCardInfo = data;
            if(this.idCardInfo){
              console.log(this.idCardInfo);
              this.idCardInfo.avatar_show =data.avatar_url;
              this.idCardInfo.avatar =data.avatar;
              this.idCardInfo.man_photo_show =data.man_photo;
              this.employeeData.man_photo_show_obj = [data.man_photo_obj];
              this.idCardInfo.nation_photo_show =data.nation_photo;
              this.employeeData.nation_photo_show_obj = [data.nation_photo_obj];
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      })
    },
    //拍照
    async openCamera(){
      //设置分辨率
      let data = {
        "mode": "0",
        "camidx":"1",
        "width":"1280",
        "height":"720"
      }
      axios.post("http://127.0.0.1:38088/device=setresolution", JSON.stringify(data)).then(()=>{
        this.dialogVisible = true;
        const image = document.getElementById('view2');
        image.src = 'http://127.0.0.1:38088/video=stream&camidx=1?1';
      });
      //await this.$http('photoService.setCamera');
    },
    takePhoto(){
      let params = {
        "filepath": "base64",
        "camidx": "1",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response=>{
        if(response){
          let data = {photo: response.data};
          this.$http('photoService.takePhoto',data, false).then(data => {
            if(data){
              this.employeeData.photo = data.avatar;
              this.employeeData.photo_obj = [];
              this.employeeData.photo_obj.push(data.file);
              this.dialogVisible = false;
              console.log(this.employeeData.photo_obj);
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    closeCamera(){
      let data = {"camidx": "1"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(()=>{
        document.getElementById('view2').src = ''
      });
      this.dialogVisible = false;
    },
    //拍银行卡等
    async openCameraMain(photoType){
      this.dialogVisibleTwo = true;
      this.photoType = photoType;
      //await this.$http('photoService.setCamera');
      const image = document.getElementById('view1');
      image.src = 'http://127.0.0.1:38088/video=stream&camidx=0?1';
    },
    closeCameraMain(){
      let data = {"camidx": "0"}
      axios.post("http://127.0.0.1:38088/video=close", JSON.stringify(data)).then(()=>{
        document.getElementById('view1').src = ''
      });
      this.dialogVisibleTwo = false;
    },
    takePhotoTwo(){
      let params = {
        "filepath": "base64",
        "camidx": "0",
        "ColorMode": "0",
        "quality": "1"
      }
      axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(params)).then(response=>{
        if(response){
          let photoData = {photo: response.data};
          this.$http('photoService.takePhotoByMainCamera',photoData, false).then(data => {
            if(data){
              switch (this.photoType){
                case "card1":
                  this.idCardInfo.man_photo_show_other = data.avatar;
                  this.employeeData.man_photo_show_other_obj = [data.file];
                  break;
                case "card2":
                  this.idCardInfo.nation_photo_show_other = data.avatar;
                  console.log(this.idCardInfo.nation_photo_show_other)
                  this.employeeData.nation_photo_show_other_obj = [data.file];
                  break;
                case "idCard1":
                  this.idCardInfo.man_photo_show = data.avatar;
                  this.employeeData.man_photo_show_obj = [data.file];
                  break;
                case "idCard2":
                  this.idCardInfo.nation_photo_show = data.avatar;
                  this.employeeData.nation_photo_show_obj = [data.file];
                  break;
              }
              this.dialogVisibleTwo = false;
            }
          }, errMsg => {
            this.$message.error(errMsg)
            console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          });
        }
      });
    },
    saveEmployeeInfo(){
      console.log(this.idCardInfo);
      if(this.idCardInfo){
        if(this.idCardInfo.id_card_no_other && this.idCardInfo.id_card_no){
          return this.$message.error("只需输入一个证件号")
        }
        if(this.idCardInfo.id_card_no){
          this.idCardInfo.card_type = "idCard";
        }else {
          this.idCardInfo.card_type = this.idCardInfo.card_type_othoer;
        }
        if(this.idCardInfo && this.idCardInfo.id_card_no){
          if(!this.idCardInfo.employee_name){
            return this.$message.error("身份证姓名不能为空")
          }
          if(this.idCardInfo.employee_name !== this.employeeData.employee_name){
            return this.$message.error("身份证姓名与员工姓名不相同")
          }
          if(this.idCardInfo.expire_date_start && this.idCardInfo.expire_date_end && this.idCardInfo.expire_date_start > this.idCardInfo.expire_date_end){
            return this.$message.error("身份证有效期结束日期不能小于开始日期");
          }
        }
      }else{
        return this.$message.error("请先上传身份证信息");
      }
      this.employeeData.idCardInfo = this.idCardInfo;
      this.loading = true;
      this.$http('employeeInfoService.editEmployeeIdCardInfo', this.employeeData, false).then(() => {
        this.$message.success("保存成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg)
        console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
        this.loading = false;
      })
    },
    async photoChangeZ(ids){
      console.log(ids)
      if (ids.length <= 0){
        this.idCardInfo.man_photo_show = ''
        return
      }
      this.idCardInfo.man_photo_show = ids[0];
    },
    async photoChangeF(ids){
      console.log(ids)
      if (ids.length <= 0){
        this.idCardInfo.nation_photo_show = ''
        return
      }
      this.idCardInfo.nation_photo_show = ids[0];
    },
    async photoChangeOtherZ(ids){
      console.log(ids);
      console.log(this.idCardInfo.man_photo_show_other);
      if (ids.length <= 0){
        this.idCardInfo.man_photo_show_other = ''
        return
      }
      this.idCardInfo.man_photo_show_other = ids[0];
    }
  },
  created() {
    this.getPosition();
    this.getJobLevel();
    this.getDepartmentList();
    this.getEmployeeType();
    this.loadEmployeeInfo();
    this.getCardType();
    this.getSexOption();
    this.getNationOption();
    this.getMarriageOption();
    this.getResidenceOption();
    this.getPoliticalOption();
  },

}
</script>

<style lang="less">
.employee-photo{
  .el-upload-list--picture-card {
    --el-upload-list-picture-card-size: 280px;
  }
  .el-upload--picture-card{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 280px;
    height: 320px;
  }
}


.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 30px;
}
.image-slot .el-icon {
  font-size: 30px;
}
</style>